const re = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/**
 * Validate UUID string.
 * @param {*} value
 * @return {boolean}
 */
export default value => typeof value === 'string' && re.test(value)
